<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="850px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form
      ref="schemeForm"
      :model="formData"
      :rules="formRules"
      label-width="180px"
      v-loading="loading"
    >
      <el-form-item label="保险公司" prop="insurance_type">
        <el-select
          v-model="formData.insurance_type"
          placeholder="请选择保险公司"
          style="width: 100%"
          :disabled="isEdit"
        >
          <el-option
            v-for="item in companyList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="保费计算方式" prop="calculate_type">
        <el-radio-group v-model="formData.calculate_type" :disabled="isEdit">
          <el-radio :label="1">按年计算</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="保费支付方式" prop="pay_type">
        <el-checkbox-group v-model="formData.pay_type">
          <el-checkbox :label="1">对公支付</el-checkbox>
          <el-checkbox :label="2">二维码</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="年龄限制">
        <div style="line-height: 32px;">
          <span>男：</span>
          <el-input-number
            v-model="formData.male_age_lower"
            :min="0"
            :max="100"
            :controls="false"
            placeholder="下限"
            style="width: 80px; margin-right: 5px;"
          />
          <span style="margin-right: 5px;">-</span>
          <el-input-number
            v-model="formData.male_age_upper"
            :min="0"
            :max="100"
            :controls="false"
            placeholder="上限"
            style="width: 80px; margin-right: 15px;"
          />
          <span style="margin-right: 5px;">女：</span>
          <el-input-number
            v-model="formData.female_age_lower"
            :min="0"
            :max="100"
            :controls="false"
            placeholder="下限"
            style="width: 80px; margin-right: 5px;"
          />
          <span style="margin-right: 5px;">-</span>
          <el-input-number
            v-model="formData.female_age_upper"
            :min="0"
            :max="100"
            :controls="false"
            placeholder="上限"
            style="width: 80px;"
          />
        </div>
      </el-form-item>

      <el-form-item label="邮箱">
        <el-input
          v-model="formData.email"
          placeholder="如果添加多个邮箱，请根据 ; 进行分割"
          style="width: 100%"
        />
      </el-form-item>

      <el-form-item label="是否自动发送邮件">
        <el-radio-group v-model="formData.is_send_email">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="价格方案">
        <el-button type="primary" size="small" @click="addPriceScheme"
          >添加价格方案</el-button
        >
      </el-form-item>

      <div
        v-for="(scheme, index) in formData.product_list"
        :key="index"
        class="price-scheme-item"
      >
        <el-card class="scheme-card">
          <div slot="header" class="clearfix">
            <span>价格方案 {{ index + 1 }}</span>
            <el-button
              style="float: right; padding: 3px 0"
              type="text"
              @click="removePriceScheme(index)"
              >删除</el-button
            >
          </div>

          <el-row :gutter="20">
            <el-col :span="20">
              <el-form-item
                label="方案名称"
                :prop="`product_list.${index}.name`"
                :rules="{
                  required: true,
                  message: '请输入方案名称',
                  trigger: 'blur'
                }"
              >
                <el-input v-model="scheme.name" placeholder="请输入方案名称" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                label="死亡伤残责任限额(万元)"
                :prop="`product_list.${index}.death_disability_coverage`"
              >
                <el-input-number
                  v-model="scheme.death_disability_coverage"
                  :min="0"
                  style="width: 70%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="医疗费用责任限额(万元)"
                :prop="`product_list.${index}.medical_cost_coverage`"
              >
                <el-input-number
                  v-model="scheme.medical_cost_coverage"
                  :min="0"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="价格档次">
            <el-table
              width="100%"
              :data="scheme.price_list"
              border
              size="small"
            >
              <el-table-column label="工种">
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.employee_type"
                    placeholder="请选择工种"
                    style="width: 100%"
                  >
                    <el-option label="文员" :value="2" />
                    <el-option label="搬运" :value="1" />
                    <el-option label="司机" :value="4" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="年度保费(元)">
                <template slot-scope="scope">
                  <el-input-number
                    v-model="scope.row.price"
                    :min="0"
                    style="width: 100%"
                  />
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="removePriceItem(index, scope.$index)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <el-button
              type="text"
              @click="addPriceItem(index)"
              style="margin-top: 10px"
            >
              <i class="el-icon-plus"></i> 新增价格档次
            </el-button>
          </el-form-item>
        </el-card>
      </div>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="handleSubmit">
        确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  getEmployerInsuranceCompanies,
  getEmployerProductList,
  saveEmployerProduct
} from "@/api/employer-insurance";

export default {
  name: "SchemeEditDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    schemeData: {
      type: Object,
      default: null
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      submitLoading: false,
      companyList: [],
      formData: {
        insurance_type: null,
        calculate_type: 1,
        pay_type: [1],
        male_age_lower: 0,
        male_age_upper: 0,
        female_age_lower: 0,
        female_age_upper: 0,
        email: "",
        is_send_email: false,
        product_list: []
      },
      formRules: {
        insurance_type: [
          { required: true, message: "请选择保险公司", trigger: "change" }
        ],
        pay_type: [
          { required: true, message: "请选择支付方式", trigger: "change" }
        ]
      }
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },

    dialogTitle() {
      return this.isEdit ? "编辑方案" : "添加方案";
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.initData();
      }
    }
  },
  methods: {
    async initData() {
      await this.loadCompanyList();
      this.initFormData();
    },

    async loadCompanyList() {
      try {
        const res = await getEmployerInsuranceCompanies({ is_ygb_price: true });
        if (res && res.err_code === 0) {
          this.companyList = res.rows || [];
        }
      } catch (error) {
        console.error("获取保险公司列表失败:", error);
      }
    },

    async initFormData() {
      if (this.isEdit && this.schemeData) {
        this.resetFormData();
        this.formData.insurance_type = this.schemeData.insurance_type;
        // 编辑模式，获取详细数据
        this.loading = true;
        try {
          const res = await getEmployerProductList({
            insurance_type: this.schemeData.insurance_type
          });
          if (res && res.err_code === 0) {
            this.parseSchemeData(res);
          }
        } catch (error) {
          console.error("获取方案详情失败:", error);
          this.$message.error("获取方案详情失败");
        } finally {
          this.loading = false;
        }
      } else {
        // 新增模式
        this.resetFormData();
      }
    },

    parseSchemeData(res) {
      const { rows, ageList } = res;
      if (rows && rows.length > 0) {
        const firstRow = rows[0];

        const payType = this.parsePayType(firstRow.pay_type);
        const maleAge = (ageList || []).find(item => Number(item.gender) === 1);
        const femaleAge = (ageList || []).find(
          item => Number(item.gender) === 2
        );

        this.formData = {
          insurance_type: firstRow.insurance_type,
          calculate_type: 1,
          pay_type: payType,
          male_age_lower: maleAge ? Number(maleAge.age_lower) : 0,
          male_age_upper: maleAge ? Number(maleAge.age_upper) : 0,
          female_age_lower: femaleAge ? Number(femaleAge.age_lower) : 0,
          female_age_upper: femaleAge ? Number(femaleAge.age_upper) : 0,
          email: firstRow.email || "",
          is_send_email: this.toBoolean(firstRow.is_send_email),
          product_list: []
        };

        // 处理产品列表
        rows.forEach(item => {
          this.formData.product_list.push({
            id: item.id,
            name: item.name || "",
            death_disability_coverage:
              (item.death_disability_coverage || 0) / 10000,
            medical_cost_coverage: (item.medical_cost_coverage || 0) / 10000,
            price_list: (item.price_list || []).map(price => ({
              id: price.id,
              employee_type: parseInt(price.employee_type),
              price: (price.price || 0) / 100,
              unit_type: price.unit_type || 1
            }))
          });
        });
      }
    },

    resetFormData() {
      this.formData = {
        insurance_type: null,
        calculate_type: 1,
        pay_type: [1],
        male_age_lower: 0,
        male_age_upper: 0,
        female_age_lower: 0,
        female_age_upper: 0,
        email: "",
        is_send_email: false,
        product_list: []
      };
      this.addPriceScheme();
    },

    addPriceScheme() {
      this.formData.product_list.push({
        name: "",
        death_disability_coverage: 0,
        medical_cost_coverage: 0,
        price_list: [
          {
            employee_type: null,
            price: 0,
            unit_type: 1
          }
        ]
      });
    },

    removePriceScheme(index) {
      if (
        this.isEdit &&
        String(this.formData.product_list[index].name).includes("-非标方案")
      ) {
        this.$message.warning("非标方案无法删除，请重试");
        return;
      }
      this.formData.product_list.splice(index, 1);
    },

    addPriceItem(schemeIndex) {
      this.formData.product_list[schemeIndex].price_list.push({
        employee_type: null,
        price: 0,
        unit_type: 1
      });
    },

    removePriceItem(schemeIndex, itemIndex) {
      const priceList = this.formData.product_list[schemeIndex].price_list;
      if (priceList.length <= 1) {
        this.$message.warning("价格档次不可为零，请重试！");
        return;
      }
      priceList.splice(itemIndex, 1);
    },

    async handleSubmit() {
      const valid = await new Promise(resolve => {
        this.$refs.schemeForm.validate(resolve);
      });
      if (!valid || !this.validateData()) return;

      this.submitLoading = true;
      try {
        const submitData = this.formatSubmitData();

        const res = await saveEmployerProduct(submitData);
        if (res && res.err_code === 0) {
          this.$message.success("保存成功");
          this.$emit("refresh");
          this.handleClose();
        } else {
          this.$message.error((res && res.err_msg) || "保存失败");
        }
      } catch (error) {
        console.error("保存方案失败:", error);
        if (error.response) {
          console.error("错误详情:", error.response.data);
          this.$message.error(
            `保存失败: ${error.response.data.err_msg || error.response.status}`
          );
        } else {
          this.$message.error("保存失败");
        }
      } finally {
        this.submitLoading = false;
      }
    },

    validateData() {
      // 校验产品列表
      if (this.formData.product_list.length === 0) {
        this.$message.error("请添加至少一个价格方案");
        return false;
      }

      for (let i = 0; i < this.formData.product_list.length; i++) {
        const product = this.formData.product_list[i];
        if (
          !product.name ||
          !Number(product.death_disability_coverage) ||
          !Number(product.medical_cost_coverage)
        ) {
          this.$message.error(`请完整填写价格方案${i + 1}的名称和责任限额`);
          return false;
        }
        if (product.price_list.length === 0) {
          this.$message.error(`价格方案${i + 1}请添加至少一个价格档次`);
          return false;
        }
        const invalidPrice = product.price_list.some(
          item => !Number(item.employee_type) || !Number(item.price)
        );
        if (invalidPrice) {
          this.$message.error(`请完整填写价格方案${i + 1}的工种和保费`);
          return false;
        }
      }

      return true;
    },

    parsePayType(value) {
      if (Array.isArray(value)) return value.map(Number);
      try {
        const result = JSON.parse(value || "[]");
        return Array.isArray(result) && result.length
          ? result.map(Number)
          : [1];
      } catch (error) {
        return [1];
      }
    },

    toBoolean(value) {
      return value === true || value === 1 || value === "1" || value === "true";
    },

    formatSubmitData() {
      const data = {
        insurance_type: this.formData.insurance_type,
        email: this.formData.email || "",
        is_send_email: this.formData.is_send_email ? "true" : "false",
        pay_type: this.formData.pay_type,
        age_list: [
          {
            age_lower: parseInt(this.formData.male_age_lower) || 0,
            age_upper: parseInt(this.formData.male_age_upper) || 0,
            gender: 1
          },
          {
            age_lower: parseInt(this.formData.female_age_lower) || 0,
            age_upper: parseInt(this.formData.female_age_upper) || 0,
            gender: 2
          }
        ],
        product_list: []
      };

      this.formData.product_list.forEach(product => {
        const productData = {
          name: product.name || "",
          death_disability_coverage: parseInt(
            (product.death_disability_coverage || 0) * 10000
          ),
          medical_cost_coverage: parseInt(
            (product.medical_cost_coverage || 0) * 10000
          ),
          price_list: []
        };

        if (product.id) {
          productData.id = product.id;
        }

        product.price_list.forEach(price => {
          const priceData = {
            employee_type: parseInt(price.employee_type),
            price: parseInt((price.price || 0) * 100),
            unit_type: 1
          };

          if (price.id) {
            priceData.id = price.id;
          }

          productData.price_list.push(priceData);
        });

        data.product_list.push(productData);
      });

      return data;
    },

    handleClose() {
      this.dialogVisible = false;
      if (this.$refs.schemeForm) this.$refs.schemeForm.resetFields();
      this.resetFormData();
    }
  }
};
</script>

<style lang="less" scoped>
.price-scheme-item {
  margin-bottom: 20px;

  .scheme-card {
    border: 1px solid #e6e6e6;
  }
}
</style>
